import { render, staticRenderFns } from "./order-summary.vue?vue&type=template&id=29b69557&scoped=true&"
import script from "./order-summary.vue?vue&type=script&lang=js&"
export * from "./order-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b69557",
  null
  
)

export default component.exports